import React from 'react';
import { GlobeIcon, ShieldCheckIcon } from 'lucide-react';
import { CountdownTimer } from '../CountdownTimer';
import { CtaButton } from '../CtaButton';
import { ScarcityBar } from '../ScarcityBar';
import { SectionHeading } from '../SectionHeading';
import { valueStack } from '../../data/content';
export function OfferStack() {
  return <section id="offer" className="bg-ink-800 px-5 py-14 sm:px-8 sm:py-20" data-id="element-218" data-mp="140ua3spnkzs">
      <div className="mx-auto max-w-2xl" data-id="element-219" data-mp="ou4ppnvqwefp">
        <SectionHeading title="Your Complete TRT Clinical System" subtitle="Everything you need to build a more organized TRT decision process." data-id="element-220" data-mp="ov69cgqtu991" />

        <div className="mt-9 overflow-hidden rounded-2xl border border-white/10 bg-ink-900" data-id="element-221" data-mp="f2qrrkjfzmoo">
          <div className="flex items-center justify-between border-b border-white/10 px-4 py-3" data-id="element-222" data-mp="k0sc08slts1q">
            <span className="text-[11px] font-bold uppercase tracking-[0.14em] text-white/50" data-id="element-223" data-mp="17qeaeu15k38o">
              Included
            </span>
            <span className="text-[11px] font-bold uppercase tracking-[0.14em] text-white/50" data-id="element-224" data-mp="1ckiff7quy174">
              Value
            </span>
          </div>

          <ul data-id="element-225" data-mp="13yuv2so9k4af">
            {valueStack.map(row => <li key={row.label} className="flex items-start justify-between gap-3 border-b border-white/5 px-4 py-3.5" data-id="element-226" data-mp="1implg2estwkc">
                <span className="text-[13px] font-medium leading-snug text-white/85 sm:text-[15px]" data-id="element-227" data-mp="1duo9yipgg9vd">
                  {row.label}
                </span>
                <span className="shrink-0 text-sm font-bold text-white/45 line-through sm:text-base" data-id="element-228" data-mp="1mp2qeolq1qg2">
                  {row.value}
                </span>
              </li>)}
          </ul>

          <div className="flex items-center justify-between gap-3 bg-ink-700 px-4 py-4" data-id="element-229" data-mp="1wm7foxav6213">
            <span className="font-display text-base font-bold uppercase tracking-[0.12em] text-white" data-id="element-230" data-mp="770y39xmuvj0">
              Total value
            </span>
            <span className="font-display text-xl font-bold text-white/60 line-through" data-id="element-231" data-mp="2aai0mltvzxl">$546</span>
          </div>

          <div className="px-4 py-7 text-center" data-id="element-232" data-mp="ryy2r68lx4vf">
            <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-teal-300" data-id="element-233" data-mp="vz86sdcu9l7n">
              Today you pay
            </p>
            <p className="mt-1 font-display text-6xl font-bold leading-none text-white sm:text-7xl" data-id="element-234" data-mp="10zcqsdcygy2m">
              $27
            </p>
            <p className="mt-3 text-xs font-semibold uppercase tracking-[0.1em] text-white/60" data-id="element-235" data-mp="1avpgl05dqrs3">
              One-time payment · Instant digital access · Lifetime access
            </p>

            <div className="mt-6 space-y-3" data-id="element-236" data-mp="1jnrf2svw1xzq">
              <CtaButton label="Get the Master System of TRT™" data-id="element-237" data-mp="1jp2jmux5r9rw" />
              <CountdownTimer data-id="element-238" data-mp="1omkvat2k833l" />
              <ScarcityBar spotsLeft={12} total={150} data-id="element-239" data-mp="1olj7do0g3m4g" />
            </div>

            <div className="mt-5 space-y-2.5 text-left" data-id="element-240" data-mp="1tmgzasb9buj5">
              <p className="flex items-start gap-2 text-[13px] leading-snug text-white/70" data-id="element-241" data-mp="1tjuis36e24os">
                <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal-300" aria-hidden="true" data-id="element-242" data-mp="1yla661w1gnac" />
                <span data-id="element-243" data-mp="3j4dx8ys8b8vr">
                  <span className="font-semibold text-white" data-id="element-244" data-mp="3e3zlb5nibesg">Automatic currency conversion:</span>{' '}
                  the price is shown in USD and converted automatically to your local currency at
                  checkout.
                </span>
              </p>
              <p className="flex items-start gap-2 text-[13px] leading-snug text-white/70" data-id="element-245" data-mp="347mtkdbivb0c">
                <ShieldCheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal-300" aria-hidden="true" data-id="element-246" data-mp="5nmzqaomj9es" />
                <span data-id="element-247" data-mp="3s391i5bpq8wf">
                  <span className="font-semibold text-white" data-id="element-248" data-mp="3s2pl4t1pnski">7-day guarantee:</span> review the
                  system and decide for yourself.
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}